import { FC } from 'react';
import { AgencyProductsBanner } from '~/src/components/blocks/agency-products/agency-products-banner/agency-products-banner';
import { ProductGroup } from '~/src/components/common-components/product-group/product-group';
import { useMatchMedia } from '~/src/hooks/use-match-media.hook';
import { MediaWidthEnum } from '~/src/models/enums/media-width.enum';
import { NoSSR } from '~/src/helpers/noSSR.helper';
import {
    getDesktopDataProducts,
    getTabletDataProducts,
} from '~/src/layouts/agency-products-layout/agency-products-layout.utils';
import type { ProductGroupInterface } from '~/src/models/types/knowledge-base.types';
import * as Styled from './agency-products-layout.styles';

interface AgencyProductsLayoutProps {
    dataProducts: Array<ProductGroupInterface>;
}

const AgencyProductsLayout: FC<AgencyProductsLayoutProps> = ({ dataProducts }) => {
    const [isDesktop] = useMatchMedia(MediaWidthEnum.desktop, { withoutSSR: true });
    const [isTablet] = useMatchMedia(MediaWidthEnum.tablet, { withoutSSR: true });
    const dataProductsFiltered = dataProducts.filter((v) => v.products.length);
    const desktopDataProducts = getDesktopDataProducts(dataProductsFiltered);
    const tabletDataProducts = getTabletDataProducts(dataProductsFiltered);

    const renderProductGroups = () => {
        return getRenderData().map((array, index) => {
            return (
                <Styled.ColumnProductGroup key={index}>
                    {array.map((value) => (
                        <ProductGroup
                            key={value.code}
                            name={value.name}
                            products={value.products}
                            bigImage={value.bigImage}
                            smallImage={value.smallImage}
                            id={value.id}
                            tag={value.tag}
                            code={value.code}
                        />
                    ))}
                </Styled.ColumnProductGroup>
            );
        });
    };

    const getRenderData = () => {
        if (isDesktop) {
            return desktopDataProducts;
        } else if (isTablet) {
            return tabletDataProducts;
        } else {
            return [dataProductsFiltered];
        }
    };

    return (
        <Styled.ContainerLayout>
            <Styled.ContentContainerAgencyProductBanner>
                <AgencyProductsBanner />
            </Styled.ContentContainerAgencyProductBanner>
            <Styled.ContentContainerProductGroups>
                <NoSSR>{renderProductGroups()}</NoSSR>
            </Styled.ContentContainerProductGroups>
        </Styled.ContainerLayout>
    );
};

export default AgencyProductsLayout;
